export const DragHandleIcon = ({ color = '#131f29', ...props }) => (
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    version="1.1"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect x="10" y="6" width="4" height="4" />
    <rect x="18" y="6" width="4" height="4" />
    <rect x="10" y="14" width="4" height="4" />
    <rect x="18" y="14" width="4" height="4" />
    <rect x="10" y="22" width="4" height="4" />
    <rect x="18" y="22" width="4" height="4" />
  </svg>
);
